import { type Guard } from '../helpers/utils/route-guards/types.ts';

type ResourceLink = { label: string; link: string; guard?: Guard };

export const RESOURCE_LINKS: readonly ResourceLink[] = [
  // {label: 'Front', link: 'https://dev-streaming-frontend.moneyballgolf.pro'},
  // {label: 'Notification', link: 'https://dev-notifications.moneyballgolf.pro/'},
  { label: 'Portal Admin', link: 'https://dev-portal-admin.moneyballgolf.pro' },
  // {label: 'Auth', link: 'https://dev-auth.moneyballgolf.pro'},
  // {label: 'Tee Box View', link: 'https://dev-tee-box.moneyballgolf.pro'},
  {
    label: 'Device Manager',
    link: 'https://dev-dm-admin.moneyballgolf.pro',
    guard: { entity: 'device_manage_admin', action: 'access' },
  },
  {
    label: 'Game Session',
    link: 'https://dev-gs-admin.moneyballgolf.pro/',
    guard: { entity: 'game_session_admin', action: 'access' },
  },
  { label: 'Auth Service', link: 'https://dev-streaming-frontend.moneyballgolf.pro' },

  { label: 'Device Manager Swagger', link: 'https://dev-dm.moneyballgolf.pro/api/docs#/' },
  { label: 'Game Session Swagger', link: 'https://dev-gs.moneyballgolf.pro/api/docs' },
  { label: 'Auth Service Swagger', link: 'https://dev-auth.moneyballgolf.pro/api/docs' },

  { label: 'Grafana', link: 'https://grafana.ajwork.work/' },
] as const;
